import $ from "jquery";
import TrackingConsent from "./TrackingConsent";

var GA4Adapter = function () {
  this.measurementIds = [];

  // ============================================================
  this.register = function () {
    $(".js_tracking_ga4_container").each((_, el) => {
      if (!this.measurementIds.includes($(el).data("id"))) {
        this.measurementIds.push($(el).data("id"));
      }
      $(el).remove();
    });
  };

  // ============================================================
  this.pageView = function (params = {}) {
    if (!this.measurementIds.length || typeof gtag === "undefined") return;

    TrackingConsent.setGtagConsent();

    this.measurementIds.forEach((id) => {
      gtag("event", "page_view", params);
    });
  };

  // ============================================================
  this.event = function (eventName, params = {}) {
    if (!this.measurementIds.length || typeof gtag === "undefined") return;

    TrackingConsent.setGtagConsent();

    this.measurementIds.forEach((id) => {
      gtag("event", eventName, params);
    });
  };
};

export default GA4Adapter;
